import {
  ApprovePairingResponse,
  PairingRequestSummary,
  type ApprovePairingRequest,
} from '@bartizo/shared';
import { apiPageRequest, apiRequest, type Page } from './client.js';

/**
 * Pairing (knowledge doc section 10, method B).
 *
 * The code travels in a request body and never in a path or a query string. It is
 * a secret with a quarter of an hour to live, and a URL is written to browser
 * history, to proxy logs and to the API's own access log — which is rule 5's "never
 * in logs" applied to the one place it is easy to forget.
 */

export const listPairingRequests = (): Promise<Page<PairingRequestSummary>> =>
  apiPageRequest('/pairing-requests', { schema: PairingRequestSummary });

export const lookupPairingCode = (code: string): Promise<PairingRequestSummary> =>
  apiRequest('/pairing-requests/lookup', {
    method: 'POST',
    body: { code },
    schema: PairingRequestSummary,
  });

export const approvePairingRequest = (
  id: string,
  body: ApprovePairingRequest,
): Promise<ApprovePairingResponse> =>
  apiRequest(`/pairing-requests/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
    body,
    schema: ApprovePairingResponse,
  });

/** Refusing a machine (P8.4): by id, without its code. */
export const denyPairingRequest = (id: string): Promise<PairingRequestSummary> =>
  apiRequest(`/pairing-requests/${encodeURIComponent(id)}/deny`, {
    method: 'POST',
    schema: PairingRequestSummary,
  });
